module.exports = __webpack_public_path__ + "img/default_cover.21384815.jpg";